<template>
  <div class="content-gene">
    <div class="gene-swipe">
      <van-swipe :autoplay="3000" @change="handleChange" style="height: 100%">
        <van-swipe-item v-for="(item, index) in list" :key="index">
          <div class="gene-name">
            <span>{{ item.gene_name }}</span>
          </div>
          <div class="flex">
            <div class="flex-item">
              <h5>位点</h5>
              <span>{{ item.rs }}</span>
            </div>
            <div class="flex-item">
              <h5>基因型</h5>
              <span>{{ item.genotype }}</span>
            </div>
            <div class="flex-item">
              <h5>检测基因型</h5>
              <span>{{ item.gene_ref }}</span>
            </div>
            <div class="flex-item">
              <h5>评价</h5>
              <i class="iconfont iconyuan high" v-if="item.repute === 'bad'"></i>
              <i class="iconfont iconyuan general" v-if="item.repute === 'normal'"></i>
              <i class="iconfont iconyuan low" v-if="item.repute === 'benefit'"></i>
            </div>
          </div>
        </van-swipe-item>
      </van-swipe>
    </div>
    <div class="content-gene-tip" v-if="list.length !== 0">
      <p class="info">
        <span>{{ index + 1 }} / {{ list.length }}</span>
        注: 本项目共计评价{{ list.length }}个位点
      </p>
    </div>
    <div class="content-gene-tip">
      <i class="iconfont iconyuan high"></i>
      <i class="iconfont iconyuan general"></i>
      <i class="iconfont iconyuan low"></i>
      分别代表有害突变、正常基因型、良性突变
    </div>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      index: 0,
    };
  },
  methods: {
    handleChange(index) {
      this.index = index;
    },
  },
};
</script>

<style lang="scss" scoped>
.content-gene {
  padding: 2em 0;
  .gene-swipe {
    height: 1.8rem;
    .gene-name {
      text-align: center;
      span {
        display: inline-block;
        border-radius: 2em;
        color: #00a0e8;
        text-align: center;
        padding: 0 0.2rem;
        line-height: 2em;
        border: 0.005rem solid #00a0e8;
      }
    }
    .flex {
      padding: 1em 1em 0;
      .flex-item {
        text-align: center;
        h5 {
          margin: 5px 0;
        }
      }
    }
  }
  .content-gene-tip {
    padding: 1em 2em 0;
    font-size: 12px;
    .info {
      color: #c1c1c2;
      text-align: right;
      span {
        float: left;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/smallGlobal/content/ContentGene.vue